import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

const customerEventsBackfillEventTypeResultSchema = z.object({
  eventType: z.string(),
  totalProcessed: z.number(),
  eventsCreated: z.number(),
  eventsAlreadyExisted: z.number(),
  errorCount: z.number(),
  lastProcessedId: z.string().optional(),
});

const customerEventsBackfillWorkflowOutputSchema = z.object({
  teamId: zExt.objectId(),
  results: z.array(customerEventsBackfillEventTypeResultSchema),
});

const customerEventsBackfillProgressSchema = z.object({
  workflowId: z.string(),
  status: createEnum(["running", "completed", "failed", "canceled"]),
  startTime: z.date().optional(),
  endTime: z.date().optional(),
  results: customerEventsBackfillWorkflowOutputSchema.optional(),
});

export const getCustomerEventsBackfill = unaryRpc({
  name: "getCustomerEventsBackfill",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    backfill: customerEventsBackfillProgressSchema.nullable(),
  }),
});
